import React, { useContext } from 'react';
import classNames from 'classnames/bind';
import { bool, func } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Button, Image } from '@thd-olt-component-react/core-ui';
import { ProductPodContext } from '../../ProductPodContext';
import styles from './ProductEditButton.module.scss';

const cx = classNames.bind(styles);
export const ProductEditButton = ({ absolute, onClick }) => {
  const { product } = useContext(ProductPodContext);

  const productButtonWrapperClass = cx(
    'product-edit-button',
    {
      'product-edit-button--absolute': absolute
    }
  );

  const handleEditClick = () => {
    if (onClick) {
      onClick({ product });
    }
  };

  return (
    <div className={productButtonWrapperClass}>
      <Button
        data-testid="product-pod-edit-button"
        onClick={handleEditClick}
        link
      >
        <Image alt="Edit" asset="pencil-gray.svg" />
      </Button>

    </div>
  );
};

ProductEditButton.propTypes = {
  absolute: bool,
  onClick: func
};

ProductEditButton.defaultProps = {
  absolute: false,
  onClick: null
};

ProductEditButton.displayName = 'ProductEditButton';
